import { isServer } from '@/utils/isServer';
export function getAssetsPath(path) {
    if (process.env.ENVIRONMENT === 'local') {
        return `${process.env.BASE_URL}/${path}`;
    }
    const bucketPath = isServer() ? 'server' : 'client';
    return `${process.env.ASSET_URL}/${bucketPath}/${path}`;
}
